<!-- 商品-订单 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">待付款</p>
		</div>

		<ul class="list">
			<li>
				<div class="item-top">
					<img src="../assets/img.png" class="item-img">
					<div class="item-sidebar">
						<div class="item-sidebar-top">
							<div class="item-row-between">
								<p class="item-name">TX36系列 开发板</p>
								<span class="item-status">待付款</span>
							</div>
							<p class="item-msg">KIT_TPC7908_XS </p>
						</div>
						<div class="item-sidebar-bottom">
							<span class="total-name">合计</span>
							<span class="total-money">¥<span>344</span></span>
						</div>
					</div>
				</div>
				<div class="item-bottom">
					<!-- 待付款显示 -->
					<button type="button" class="footer-btn border">取消订单</button>
					<button type="button" class="footer-btn">立即付款</button>
					<!-- 待收货显示 -->
					<!-- <button type="button" class="footer-btn border">查看物流</button>
					<button type="button" class="footer-btn">确认收货</button> -->
				</div>
			</li>
			<div class="normal-box-small">
				<img src="../assets/normal-8.png">
				暂无订单
			</div>

		</ul>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background: linear-gradient(180deg, #FFFFFF, #F3F3F3);
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 44px 0 0;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}



	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 12px 10px 8px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 16px;
		color: #888888;
		padding: 33px 0;
	}

	.normal-box-small>img {
		width: 205px;
		margin-bottom: 29px;
	}

	.item-top {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.item-img {
		width: 80px;
		height: 80px;
		border-radius: 8px;
		margin-right: 10px;
	}

	.item-sidebar {
		flex: 1;
		height: 78px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-sidebar-top {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.item-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-name {
		flex: 1;
		font-size: 16px;
		color: #222222;
		font-weight: bold;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		margin-right: 10px;
	}

	.item-status {
		color: #FF4954;
		font-size: 12px;
	}

	.item-msg {
		width: 100%;
		color: #999999;
		font-size: 10px;
		margin-top: 4px;
	}

	.item-sidebar-bottom {
		width: 100%;
		text-align: right;
	}

	.total-name {
		font-size: 10px;
		color: #222222;

	}

	.total-money {
		font-size: 12px;
		color: #222222;
		font-weight: bold;
	}

	.total-money>span {
		font-size: 16px;
	}

	.item-bottom {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-top: 14px;
	}

	.footer-btn {
		width: 90px;
		height: 32px;
		line-height: 32px;
		border-radius: 50px;
		border: 1px solid #2A63F3;
		background-color: #FFFFFF;
		color: #2A63F3;
		font-size: 15px;
		margin-left: 16px;
	}

	.footer-btn.border {
		border: 1px solid #979797;
		background-color: #FFFFFF;
		color: #444444;
	}
</style>
